// swiper/bundle（全機能）ではなく使う機能だけ読み込む。CSS は style.scss に含まれている

import Swiper, { Pagination } from "swiper";
import { inview } from '../../lib/inview';

export function news(page) {

	const optionTop = {
		// Optional parameters
		direction: 'horizontal',
		//centeredSlides: true,
		loop: true,
		//slidesPerView: "auto",
		slidesPerView: 4,
		//spaceBetween: 30,
		speed: 6000,
		allowTouchMove: false, // スワイプ無効
		autoplay: {
			delay: 0, // 途切れなくループ
		},
	}

	const optionNews = {
		direction: 'horizontal',
		loop: false,
		slidesPerView: 3.4,
		spaceBetween: 90,
		speed: 600,
		modules: [Pagination],
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		breakpoints: {

		}
	}
	const breakPoint = 719;
	let swiper;
	if (window.innerWidth >= breakPoint) {
		swiper = new Swiper('#newsSwiper', optionNews);
	} else {
		swiper = undefined;
	}

	window.addEventListener('resize', () => {
		if (window.innerWidth >= breakPoint) {
			if (swiper) return;
			swiper = new Swiper('#newsSwiper', optionNews);
		} else {
			if (!swiper) return;
			swiper.destroy();
			swiper = undefined;
		}
	}, false);







	const slides = Array.from(document.getElementsByClassName("swiper-slide"));


	inview(document.getElementById('newsSwiper'), (direction) => {
		if (direction == "down") {
			let countNum = 0;

			slides.forEach((slide) => {
				setTimeout(function () {
					slide.classList.add('active');
				}, 200 * countNum);

				countNum++;
			});

		} else {
			slides.forEach((slide) => {
				slide.classList.remove('active');
			});
		}
	});
}
